import { FLOW_SHEET_SECTIONS } from '../../constants/flowSheet';

export default function FlowSheetSection({ sectionKey, children, action }) {
  const cfg = FLOW_SHEET_SECTIONS[sectionKey];

  return (
    <section className="mb-4" id={`flowsheet-${sectionKey}`} data-flowsheet-section={sectionKey}>
      <div
        className={`sticky top-0 z-10 mb-2 rounded-lg border px-3 py-2 ${cfg.headerClass}`}
      >
        <h3 className="text-sm font-bold">{cfg.title}</h3>
      </div>
      <div className="card-surface p-3">{children}</div>
      {action && <div className="mt-2 flex justify-end">{action}</div>}
    </section>
  );
}
